module.exports = __webpack_public_path__ + "assets/media/pictaut.f7e35966.mp3";